import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useRequestEditLink } from '~/hooks/account';
import getErrorAuthMessage from '~/utils/auth-helpers';
import EmailResetPwdForm from '~/components/form/EmailResetPwdForm';
import logoU from '~/assets/images/logo-u.png';
import imgSignin from '~/assets/images/signin-logo.png';
import imgDates from '../../assets/images/dates.png';
import styles from './request-edit-link.module.scss';
import { CONTACT_EMAIL } from '~/constants';

const RequestEditLink = () => {
  const navigate = useNavigate();
  const {
    mutateAsync: requestEditLink,
    error,
  } = useRequestEditLink();
  const errorApi: any = error;

  const submit = async (data: { email: string }) => {
    await requestEditLink(data);
    navigate('/modifier-inscription/confirmation');
  };

  const errorMessage = useMemo(() => {
    if (!error) return '';
    const msg = getErrorAuthMessage(errorApi?.response?.data?.error || errorApi?.response?.data);
    return msg;
  }, [errorApi, error]);

  return (
    <div className={styles.requestEditLink}>
      <Link to="/" className={styles.logo}>
        <img src={logoU} alt="Logo Coopérative U" />
      </Link>
      <div className={styles.container}>
        <div className={styles.imgContainer}>
          <h1>Bienvenue au</h1>
          <img src={imgSignin} alt="Bienvenue au salon U" />
          <img src={imgDates} alt="Dates du salon" className={styles.dates}/>
        </div>
        <div className={styles.form}>
          <h2>Veuillez saisir l&apos;adresse mail utilisée lors de votre inscription en 2026.</h2>
          <EmailResetPwdForm
            submit={submit}
            submitLabel="Envoyer"
            signinLink=""
            signinLabel=""
            errorMessage={errorMessage}
          />
          <span className={styles.caption}>
            Je ne reçois pas d&apos;email. Contactez-nous : {CONTACT_EMAIL}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RequestEditLink;
